module.exports = __webpack_public_path__ + "static/join-15a20855fc4302c970204b1d356c30e6.jpg";